module.exports = __webpack_public_path__ + "static/media/The Hound.93f47be2.jpg";